import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteProjectForm = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}project_forms/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteProjectForm;
